import React from 'react';
import utilsStyles from '../../../styles/modules/utils.module.scss';
import styles from './OptionNotes.module.scss';

export type OptionNotesProps = {
  prizeOptionText: string | null;
};

function OptionNotes({ prizeOptionText }: OptionNotesProps) {
  return (
    <div className={`${styles.section} ${utilsStyles.mtSmall}`}>
      <div className={styles.notesList}>
        <p className={styles.noteItem}>{prizeOptionText}</p>
      </div>
    </div>
  );
}

export default OptionNotes;
